import AxiosDefaultSetting from "../AxiosDefault";
import { createAsyncThunk } from "@reduxjs/toolkit";

//add disciplinary measures
export const addEmployeeDisciplinaryMeasure = createAsyncThunk(
  "emp/addDisciplinaryMeasure",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-disciplinary-measures", //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update disciplinary measure
export const updateEmployeeDisciplinaryMeasure = createAsyncThunk(
  "emp/updateDisciplinaryMeasure",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-disciplinary-measures/${id}`, // endpoint with ID
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete disciplinary measure
export const deleteEmployeeDisciplinaryMeasure = createAsyncThunk(
  "emp/deleteDisciplinaryMeasure",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-disciplinary-measures/${id}`, // endpoint with ID
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update benefit
export const updateEmployeeBenefit = createAsyncThunk(
  "emp/updateBenefit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-benefits/${id}`, // endpoint with ID
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete benefit
export const deleteEmployeeBenefit = createAsyncThunk(
  "emp/deleteBenefit",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-benefits/${id}`, // endpoint with ID
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//add benefit
export const addEmployeeBenefit = createAsyncThunk(
  "emp/addBenefit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-benefits", //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//add contract
export const addEmployeeContract = createAsyncThunk(
  "emp/addContract",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-contracts", //endpoint
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update contract
export const updateEmployeeContract = createAsyncThunk(
  "emp/updateContract",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-contracts/${id}`, // endpoint with ID
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete contract
export const deleteEmployeeContract = createAsyncThunk(
  "emp/deleteContract",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-contracts/${id}`, // endpoint with ID
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Add Certificate
export const addEmployeeCertificate = createAsyncThunk(
  "emp/addCertificate",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-certificates", // endpoint for certificates
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update Certificate
export const updateEmployeeCertificate = createAsyncThunk(
  "emp/updateCertificate",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-certificates/${id}`, // endpoint with ID for certificates
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete Certificate
export const deleteEmployeeCertificate = createAsyncThunk(
  "emp/deleteCertificate",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-certificates/${id}`, // endpoint with ID for certificates
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//get employee certificates
export const getEmployeeCertificates = createAsyncThunk(
  "emp/getCertificates",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      entity = "",
      user_profile_id = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      entity,
      user_profile_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-certificates?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get employee work booklet
export const getEmployeeWorkBooklet = createAsyncThunk(
  "emp/getWorkBooklet",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_profile_id = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_profile_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-work-booklets?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Add Work Booklet
export const addEmployeeWorkBooklet = createAsyncThunk(
  "emp/addWorkBooklet",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-work-booklets", // endpoint for work booklets
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update Work Booklet
export const updateEmployeeWorkBooklet = createAsyncThunk(
  "emp/updateWorkBooklet",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-work-booklets/${id}`, // endpoint with ID for work booklets
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete Work Booklet
export const deleteEmployeeWorkBooklet = createAsyncThunk(
  "emp/deleteWorkBooklet",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-work-booklets/${id}`, // endpoint with ID for work booklets
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//get employee documents
export const getEmployeeDocuments = createAsyncThunk(
  "emp/getDocuments",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_profile_id = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_profile_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/files?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

//get employee family members
export const getEmployeeFamilyMembers = createAsyncThunk(
  "emp/getFamilyMembers",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_profile_id = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_profile_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-family-members?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Add Family Member
export const addFamilyMember = createAsyncThunk(
  "emp/addFamilyMember",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-family-members", // endpoint for family members
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update Family Member
export const updateFamilyMember = createAsyncThunk(
  "emp/updateFamilyMember",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-family-members/${id}`, // endpoint with ID for family members
        data: data,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete Family Member
export const deleteFamilyMember = createAsyncThunk(
  "emp/deleteFamilyMember",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-family-members/${id}`, // endpoint with ID for family members
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Get Employee Permits
export const getEmployeePermits = createAsyncThunk(
  "emp/getPermits",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_profile_id = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_profile_id,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-permits?${queryString}`, // endpoint for permits
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Add Permit
export const addEmployeePermit = createAsyncThunk(
  "emp/addPermit",
  async (data, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: "/user-permits", // endpoint for permits
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update Permit
export const updateEmployeePermit = createAsyncThunk(
  "emp/updatePermit",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-permits/${id}`, // endpoint with ID for permits
        data: data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Delete Permit
export const deleteEmployeePermit = createAsyncThunk(
  "emp/deletePermit",
  async (id, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "DELETE",
        url: `/user-permits/${id}`, // endpoint with ID for permits
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

//get employee days of annual leave
export const getAnnualLeaveDays = createAsyncThunk(
  "emp/getAnnualLeaveDays",
  async (data, { rejectWithValue }) => {
    const {
      order_type = "",
      order_by = "",
      page_size = "",
      page = "",
      user_profile_id = "",
      year = "",
      ...rest
    } = data;
    const queryString = new URLSearchParams({
      order_type,
      order_by,
      page_size,
      page,
      user_profile_id,
      year,
    }).toString();
    try {
      const response = await AxiosDefaultSetting({
        method: "GET",
        url: `/user-days-of-annual-leavings?${queryString}`, //endpoint
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// Create employee days of annual leave
export const createEmployeeAnnualLeaveDays = createAsyncThunk(
  "emp/createEmployeeAnnualLeaveDays",
  async ({ data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "POST",
        url: `/user-days-of-annual-leavings`,
        data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// Update employee days of annual leave
export const updateEmployeeAnnualLeaveDays = createAsyncThunk(
  "emp/updateEmployeeAnnualLeaveDays",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const response = await AxiosDefaultSetting({
        method: "PUT",
        url: `/user-days-of-annual-leavings/${id}`, // endpoint with ID
        data,
        contentType: "multipart/form-data",
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
